import React, { useState, useEffect, useRef } from "react";
import { Segment, Label, Form, Icon } from "semantic-ui-react";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Marker as LeafletMarker, icon } from "leaflet";
import iconRetinaUrl from "leaflet/dist/images/marker-icon-2x.png";
import iconUrl from "leaflet/dist/images/marker-icon.png";
import shadowUrl from "leaflet/dist/images/marker-shadow.png";
import * as L from "leaflet";
import "leaflet-routing-machine";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import { calcular_trayecto } from "../../utils/traductor";
import { Alert } from "@mui/material";

LeafletMarker.prototype.options.icon = icon({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41],
});

export function CalcularTrayecto({
  LatitudPartida,
  setLatitudPartida,
  LongitudPartida,
  setLongitudPartida,
  LatitudDestino,
  setLatitudDestino,
  LongitudDestino,
  setLongitudDestino,
  Localidad,
  Kms,
  setKms,
  Min,
  setMin,
  PrecioBase,
  PartidaUbicacion,
  setPartidaUbicacion,
  DestinoUbicacion,
  setDestinoUbicacion,
}) {
  // The map instance:
  const [map, setMap] = useState(null);

  const [routingMachine, setRoutingMachine] = useState(null);

  // Routing machine ref
  const RoutingMachineRef = useRef(null);

  //////////////////////////////////////////////////////////////

  // Create the routing-machine instance:
  useEffect(() => {
    if (!map) return;

    if (map) {
      RoutingMachineRef.current = L.Routing.control({
        position: "topleft",
        lineOptions: {
          addWaypoints: false,
          draggableWaypoints: false,
          styles: [
            {
              color: "#757de8",
              weight: 4,
            },
          ],
        },
        language: localStorage.getItem("Idioma") === "Español" ? "es" : "en",
        formatter: new L.Routing.Formatter({
          language: localStorage.getItem("Idioma") === "Español" ? "es" : "en",
        }),
        waypoints: [
          [LatitudPartida, LongitudPartida],
          [LatitudDestino, LongitudDestino],
        ],
        routeWhileDragging: false,
        extendToWaypoints: false,
        missingRouteTolerance: 10,
        collapsible: true,
        show: false,
      })
        .on("routesfound", function (e) {
          var routes = e.routes;
          var summary = routes[0].summary;
          setKms((summary.totalDistance / 1000).toFixed(2));
          setMin(Math.round((summary.totalTime % 3600) / 60));
        })
        .on("waypointschanged", function (e) {
          setLatitudPartida(e.waypoints[0].latLng.lat);
          setLongitudPartida(e.waypoints[0].latLng.lng);

          setLatitudDestino(e.waypoints[1].latLng.lat);
          setLongitudDestino(e.waypoints[1].latLng.lng);
        });
      setRoutingMachine(RoutingMachineRef.current);
    }
  }, [map]);

  // Set waypoints when start and end points are updated:
  useEffect(() => {
    if (routingMachine) {
      routingMachine.addTo(map);
      routingMachine.setWaypoints([
        [LatitudPartida, LongitudPartida],
        [LatitudDestino, LongitudDestino],
      ]);
    }
  }, [
    routingMachine,
    [LatitudPartida, LongitudPartida],
    [LatitudDestino, LongitudDestino],
  ]);

  //////////////////////////////////////////////////////////////

  return (
    <div>
      <Segment
        style={{
          boxShadow: "none",
          borderColor: "white",
        }}
      >
        <Label
          attached="top"
          style={{
            backgroundColor: "rgb(229, 246, 253)",
            color: "rgb(1, 67, 97)",
          }}
        >
          {calcular_trayecto}
        </Label>

        <Form.Field style={{ textAlign: "center" }}>
          <Label
            style={{
              backgroundColor: "white",
              color: "#153B5E",
              borderColor: "#153B5E",
            }}
          >
            <Icon name="map outline" />
            {Kms} Kms
          </Label>
          <Label
            style={{
              backgroundColor: "white",
              color: "#153B5E",
              borderColor: "#153B5E",
            }}
          >
            <Icon name="clock outline" />
            {Min} Min
          </Label>
          <Label
            style={{
              backgroundColor: "white",
              color: "#153B5E",
              borderColor: "#153B5E",
            }}
          >
            <Icon name="dollar sign" />
            {PrecioBase}
          </Label>
        </Form.Field>
      </Segment>

      <Segment style={{ boxShadow: "none" }}>
        <MapContainer
          id="Mapa"
          name="Mapa"
          className="Mapa"
          doubleClickZoom={false}
          style={{
            height: "70vh",
            zIndex: "0",
            marginTop: "-16px",
            marginLeft: "-28px",
            marginRight: "-28px",
            marginBottom: "-20px",
          }}
          center={[LatitudDestino, LongitudDestino]}
          zoom={10}
          scrollwheelzoom={false}
          whenCreated={(map) => setMap(map)}
        >
          <TileLayer
            attribution='&amp;copy <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
        </MapContainer>
      </Segment>
    </div>
  );
}
